import React from 'react';
import { Form, Navbar } from 'react-bootstrap';
import AdminMenu from './AdminMenu';
import '../styles/admin-theme.css';

const AdminHeader = ({
  schemas,
  selectedSchema,
  onSchemaChange,
  onLogout,
  menuTabs,
}) => {
  return (
    <div className='admin-header'>
      <Navbar expand='lg'>
        <div className='container-fluid d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
            <img src='/vgrow-logo.jpg' alt='vGrow' className='admin-logo' />
            <span className='admin-brand'>vGrowCRM</span>
          </div>

          <div className='d-flex align-items-center gap-3'>
            <Form.Select
              className='admin-schema-select'
              value={selectedSchema || ''}
              onChange={event => onSchemaChange(event.target.value)}
            >
              <option value='' disabled>
                Select schema
              </option>
              {schemas.map(schema => (
                <option key={schema.value} value={schema.value}>
                  {schema.label}
                </option>
              ))}
            </Form.Select>

            <button className='btn admin-logout-btn' onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </Navbar>

      <div className='admin-header-tabs'>
        <AdminMenu tabs={menuTabs} />
      </div>
    </div>
  );
};

export default AdminHeader;
